package com.merkost.handpass.admin.contract

import com.merkost.handpass.admin.auth.AuthState
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class SidebarState(
    val pendingCount: Int = 0,
    val authState: AuthState.LoggedIn? = null,
    val currentPath: String = "/",
    val envLabel: EnvLabel = EnvLabel.PROD,
) : MVIState

enum class EnvLabel { PROD, STAGING, LOCAL }

sealed interface SidebarIntent : MVIIntent {
    data class SetCurrentPath(val path: String) : SidebarIntent
    data class SetAuth(val auth: AuthState.LoggedIn) : SidebarIntent
    data object Refresh : SidebarIntent
    data class ReactToFocusTick(val tick: Long) : SidebarIntent
}

sealed interface SidebarAction : MVIAction {
    data class Navigate(val path: String) : SidebarAction
    data object Logout : SidebarAction
}
